// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyCUf3IPAVeBD0k6c5SG3PtJlaIxf6RyeMo",
  authDomain: "imbscongress2021.firebaseapp.com",
  projectId: "imbscongress2021",
  storageBucket: "imbscongress2021.appspot.com",
  messagingSenderId: "397419433964",
  appId: "1:397419433964:web:0d86ead91013cde1c7bac9",
  measurementId: "G-Y9X2M949LC"
}
// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/imbscongress2021.appspot.com/o/'